import {BaseDateCalendarDay} from "../base/BaseDateCalendarDay";
import type {StemDate} from "../../../../../stem-core/time/Date";
import type {NodeAttributes} from "../../../../../stem-core/ui/NodeAttributes";


interface DateCalendarDayOptions {
    selectedDate?: StemDate;
}

export class DateCalendarDay extends BaseDateCalendarDay<DateCalendarDayOptions> {
    applyDateStyle(attr: NodeAttributes) {
        const {selectedDate, hoverDate} = this.options;
        const {styleSheet} = this;

        // The circle.
        if (hoverDate && this.isEqualTo(hoverDate)) {
            attr.addClass(styleSheet.hoverCircle);
        } else if (selectedDate && this.isEqualTo(selectedDate)) {
            attr.addClass(styleSheet.greenCircle);
            attr.addClass(styleSheet.lightFont);
        }
    }
}
